
import Vue from "vue";
import { roofStructureTableColumns } from "./RoofStructureTable";
import { ITableWrapperColumns } from "@/types";
import NoResultsFound from "@/components/NotFound/NoResultsFound.vue";
import {
  roofStructureMapActions,
  roofStructureMapGetters
} from "@/store/modules/roofStructure";

interface IRoofStructureData {
  tableActions: any[];
  errorMessage: string;
  isLoading: boolean;
  loading: boolean;
  successMessage: string;
  roofStructureId: string;
  tableRowActions: any[];
  loadingText: string;
}

export default Vue.extend({
  name: "ListRoofStructures",
  components: {
    NoResultsFound
  },
  data(): IRoofStructureData {
    return {
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      tableActions: [],
      loading: false,
      roofStructureId: "",
      tableRowActions: [
        { label: "Edit", value: "edit", faIcon: "edit" },
        {
          label: "Delete",
          value: "delete",
          faIcon: "trash-alt",
          class: "bg-red-400 text-white hover:text-white hover:bg-red-500"
        }
      ],
      loadingText: ""
    };
  },
  methods: {
    ...roofStructureMapActions(["getRoofStructures", "deleteRoofStructure"]),
    onToolbarItemClick(event: string) {
      switch (event) {
        case "createRoofStructure":
          this.$router.push("/admin/roofStructure/create");
          break;
      }
    },
    async fetchPageData(queryObject: any): Promise<any> {
      try {
        this.loading = true;
        this.loadingText = "Loading roof structures. Please wait...";
        this.$emit("scrollTop");
        await this.getRoofStructures({ query: queryObject });
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
        this.loadingText = "";
      }
    },
    async viewCallback(dataReceived: any): Promise<any> {
      const { _id } = dataReceived;
      this.$router.push(`/admin/${_id}/roofStructure`).catch(() => {});
    },
    async handleResponseAction(payload: any) {
      const { data } = payload;
      switch (payload.name) {
        case "delete":
          this.deleteCallback(data._id);
          break;
        case "edit":
          this.$router.push(`/admin/${data._id}/roofStructure`);
          break;
        default:
          this.errorMessage = "Operation specified is not supported";
      }
    },
    async deleteOneRoofStructure(): Promise<void> {
      try {
        this.isLoading = true;
        this.loadingText = "Deleting roof structure. Please wait...";
        await this.deleteRoofStructure(this.roofStructureId);
        this.$modal.hide("roofStructureDeleteModal");
        this.$appNotifySuccess("Roof Structure Successfully Deleted");
      } catch (e) {
        this.errorMessage = e.message;
        this.$bugSnagClient.notify(e);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    },
    deleteCallback(id: string): void {
      this.roofStructureId = id;
      this.$modal.show("roofStructureDeleteModal");
    }
  },
  computed: {
    ...roofStructureMapGetters([
      "roofStructures",
      "getTotalRecords",
      "getRoofStructuresLinks"
    ]),
    tableColumns(): ITableWrapperColumns {
      return roofStructureTableColumns;
    }
  }
});
